import { UserLoginType } from 'client/types';
import { RootState } from './../../../client/redux/index';

export const getLoginFormType = ({ ...state }: RootState): UserLoginType => {
  return state.login.loginFormType;
};
